import { render, staticRenderFns } from "./SectionTicker.vue?vue&type=template&id=d519401a"
import script from "./SectionTicker.vue?vue&type=script&lang=js"
export * from "./SectionTicker.vue?vue&type=script&lang=js"
import style0 from "./SectionTicker.vue?vue&type=style&index=0&id=d519401a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports